const EXPORTS = [
  { href: '/api/me/data-export', label: 'Complete JSON export' },
  { href: '/api/me/data-export/preferences.csv', label: 'Preferences CSV' },
  { href: '/api/me/data-export/tracked-vendors.csv', label: 'Tracked vendors CSV' },
  { href: '/api/me/data-export/keyword-watches.csv', label: 'Keyword watches CSV' },
  { href: '/api/me/data-export/saved-searches.csv', label: 'Saved searches CSV' },
  { href: '/api/me/data-export/regulatory-watches.csv', label: 'Regulatory watches CSV' },
  {
    href: '/api/me/data-export/regulatory-deliveries.csv',
    label: 'Regulatory deliveries CSV',
  },
] as const

export function DataExportSection() {
  return (
    <>
      <div
        role="region"
        aria-label="Data export downloads"
        className="space-y-4"
      >
        <div className="max-w-prose space-y-2 text-sm text-muted-foreground">
          <p>
            Download the data IntelHub currently retains for your account,
            including preferences, watches, saved searches, and tracked vendors.
          </p>
          <p>
            Each file is a point-in-time portability snapshot, not a restore
            package. It covers IntelHub only. IntelHub does not retain the
            generated files after your browser receives them.
          </p>
        </div>

        <ul className="divide-y divide-border rounded-md border border-border">
          {EXPORTS.map(({ href, label }) => (
            <li key={href}>
              <a
                href={href}
                target="_blank"
                rel="noopener"
                className="flex min-h-11 items-center justify-between gap-4 px-3 py-2 text-sm font-medium text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <span>{label}</span>
                <span className="text-xs font-normal text-muted-foreground">
                  Download
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <p className="text-xs text-muted-foreground">
        Read the{' '}
        <a
          href="/docs/data-export.md"
          target="_blank"
          rel="noopener"
          className="font-medium text-primary underline underline-offset-4"
        >
          export schema and limits
        </a>
        . This document is available while you are online.
      </p>
    </>
  )
}
